import moment, { Moment } from 'moment-timezone';
import { AccountApiModel } from '../../../api/accounts/models/account.api.model';
import { userPermissionsEnum } from '../enums/user-permissions.enum';
import { MfaTypesEnum } from './mfa.model';
import { SsoProvider } from './sso-provider.model';

export class AccountModel {
    id: number;
    name: string;
    internal: boolean;
    active: boolean;
    isExpiryDatePast?: boolean;
    // services?: accountServicesEnum[];
    startDate?: Moment;
    expiryDate?: Moment;
    partnerResellerId?: number;
    partnerResellerName?: string;
    neptuneOnly?: boolean;
    permissions: userPermissionsEnum[];
    enabledMfaTypes?: MfaTypesEnum[];
    isMfaRequired?: boolean;
    isMfaEnabled?: boolean;
    preserveData?: boolean;
    ssoProvider?: SsoProvider;
    users?: any;
    /** Not writable - Not included in toApiModel */
    availableSsoProviders?: SsoProvider[];
    accessTokens: string[];
    clientId?: string;
    hasUiAccess?: boolean;
    mediaApiPartnerResellerId?: number;
    /** Not writable - Not included in toApiModel */
    mediaApiPartnerResellerName?: string;
    autoRenew?: boolean;

    constructor(apiEntity?: AccountApiModel) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Constructs this model from the provided API entity
     */
    private constructFromApiEntity(apiEntity: AccountApiModel): void {
        this.id = apiEntity.id;
        this.name = apiEntity.name;
        this.internal = apiEntity.internal;

        if (apiEntity.serviceIds) {
            // this.services = [...apiEntity.serviceIds];
        }

        if (apiEntity.permissionIds) {
            this.permissions = [...apiEntity.permissionIds];
        }

        this.expiryDate = moment(apiEntity.expiryDate).utc();
        if (!apiEntity.startDate) {
            this.startDate = moment(apiEntity.createdDate).utc();
        } else {
            this.startDate = moment(apiEntity.startDate).utc();
        }

        this.isExpiryDatePast = this.expiryDate < moment().utc();

        this.partnerResellerId = apiEntity.partnerResellerId;
        this.partnerResellerName = apiEntity.partnerResellerName;
        this.active = apiEntity.active;
        this.neptuneOnly = apiEntity.neptuneOnly;
        this.enabledMfaTypes = apiEntity.enabledMfaTypes;
        this.isMfaRequired = apiEntity.isMfaRequired;
        this.isMfaEnabled = apiEntity.isMfaEnabled;
        this.preserveData = apiEntity.preserveData;
        this.ssoProvider = apiEntity.ssoProvider ? new SsoProvider(apiEntity.ssoProvider) : null;
        this.availableSsoProviders = [];
        if (apiEntity.availableSsoProviders?.length) {
            this.availableSsoProviders = apiEntity.availableSsoProviders.map(apiProvider => new SsoProvider(apiProvider));
        }

        this.accessTokens = apiEntity.accessTokens;
        this.clientId = apiEntity.clientId;

        this.hasUiAccess = apiEntity.hasUiAccess;
        this.mediaApiPartnerResellerId = apiEntity.mediaApiPartnerResellerId;
        this.mediaApiPartnerResellerName = apiEntity.mediaApiPartnerResellerName;
        this.autoRenew = apiEntity.autoRenew ?? true;
    }

    /**
     * Constructs the default version of this
     */
    private constructDefault(): void {
        this.id = null;
        this.name = null;
        this.internal = false;
        // this.services = [];
        this.permissions = [];
        this.autoRenew = true;
    }

    toApiModel(): AccountApiModel {
        return {
            id: this.id,
            name: this.name,
            internal: this.internal,
            active: this.active,
            // serviceIds: this.services,
            expiryDate: this.expiryDate.format(),
            // We don't need to return the created date, just the start date
            startDate: this.startDate.format(),
            partnerResellerId: this.partnerResellerId,
            neptuneOnly: this.neptuneOnly,
            permissionIds: this.permissions,
            enabledMfaTypes: this.enabledMfaTypes,
            isMfaRequired: this.isMfaRequired,
            isMfaEnabled: this.isMfaEnabled,
            preserveData: this.preserveData,
            ssoProvider: this.ssoProvider?.toApiModel(),
            accessTokens: this.accessTokens,
            clientId: this.clientId,
            hasUiAccess: this.hasUiAccess,
            mediaApiPartnerResellerId: this.mediaApiPartnerResellerId,
            autoRenew: this.autoRenew
        };
    }
}
